import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { CheckCircle, Zap, Users, Shield, Clock, Award } from 'lucide-react';

const FilloutWhyChooseSection = () => {
  const { t } = useTranslation('fillout');

  const reasonsData = t('whyChoose.items', { returnObjects: true });
  const reasons = Array.isArray(reasonsData) ? reasonsData as Array<{
    title: string;
    description: string;
  }> : [];

  const reasonIcons = [Zap, Users, Shield, Clock, Award, CheckCircle];
  const reasonColors = ["text-yellow-500", "text-blue-500", "text-green-500", "text-purple-500", "text-orange-500", "text-pink-500"];

  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center space-y-3 sm:space-y-4 mb-12 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold">
            {t('whyChoose.title')}
          </h2>
          <p className="text-lg sm:text-xl text-muted-foreground max-w-2xl mx-auto">
            {t('whyChoose.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {reasons.map((reason, index) => {
            const IconComponent = reasonIcons[index];
            const colorClass = reasonColors[index];
            return (
              <Card key={index} className="group hover:shadow-xl transition-all duration-300 border-primary/10 hover:border-primary/30">
                <CardHeader className="space-y-4 p-4 sm:p-6">
                  <div className="flex items-center gap-4">
                    <div className="p-3 bg-gradient-to-br from-primary/10 to-primary/20 rounded-lg group-hover:scale-110 transition-transform duration-300">
                      <IconComponent className={`w-6 h-6 ${colorClass}`} />
                    </div>
                    <CardTitle className="text-lg sm:text-xl group-hover:text-primary transition-colors">
                      {reason.title}
                    </CardTitle>
                  </div>
                </CardHeader>
                <CardContent className="p-4 sm:p-6 pt-0">
                  <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">
                    {reason.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FilloutWhyChooseSection;